import { forceLoadImages, observePanelImages } from '@theme/tab-panel-images';

/**
 * @param {HTMLElement} section
 * @param {{ keyboardNav?: boolean, focusOnActivate?: boolean }} [options]
 */
export function initTabPanels(section, options = {}) {
  const { keyboardNav = false, focusOnActivate = false } = options;
  const tabs = Array.from(section.querySelectorAll('.tab-item'));
  const contents = Array.from(section.querySelectorAll('.collection-tab-content'));

  if (!tabs.length || !contents.length) return;

  /**
   * @param {HTMLElement} tab
   */
  const activateTab = (tab) => {
    const target = tab.getAttribute('data-target');

    tabs.forEach((t) => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });

    contents.forEach((content) => {
      content.classList.remove('active');
      content.setAttribute('hidden', '');
    });

    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');

    if (focusOnActivate) {
      tab.focus();
    }

    const activeContent = target ? section.querySelector(`#${target}`) : null;
    if (activeContent) {
      activeContent.classList.add('active');
      activeContent.removeAttribute('hidden');
      window.dispatchEvent(new Event('resize'));
      forceLoadImages(activeContent);
    }
  };

  observePanelImages(section, () => section.querySelector('.collection-tab-content.active'));

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      activateTab(tab);
    });

    if (!keyboardNav) return;

    tab.addEventListener('keydown', (event) => {
      let nextIndex = null;

      if (event.key === 'ArrowRight') {
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex !== null) {
        event.preventDefault();
        activateTab(tabs[nextIndex]);
      }
    });
  });
}

const TAB_PANEL_SECTIONS = [
  { selector: '[data-testid="product-list-tabs"]', keyboardNav: true, focusOnActivate: true },
  { selector: '[data-testid="collection-list-tabs"]', keyboardNav: false, focusOnActivate: false },
  { selector: '[data-testid="custom-list-tabs"]', keyboardNav: false, focusOnActivate: false },
  { selector: '[data-testid="players-tabs"]', keyboardNav: false, focusOnActivate: false },
];

for (const { selector, keyboardNav, focusOnActivate } of TAB_PANEL_SECTIONS) {
  document.querySelectorAll(selector).forEach((section) => {
    if (section instanceof HTMLElement) {
      initTabPanels(section, { keyboardNav, focusOnActivate });
    }
  });
}
